import React from 'react'
import { Row, Col } from "reactstrap"
const BreadcrumbTitle = ({ title }) => {
    return (
        <Row>
            <Col className="col-12">
                <div className='page-title-box'>
                    <h4 className="mb-sm-0 font-size-18">{title}</h4>
                </div>
            </Col>
        </Row>
    )
}

export default BreadcrumbTitle;
